import { memo } from "react";
import styled from "styled-components";

interface Props {
  header: string;
  count: number;
}

const StyledContainer = styled.div`
  border: 2px solid;
  width: 220px;
  height: 80px;
  text-align: center;
  h5 {
    margin-bottom: 0px;
  }
  p {
    margin-top: 5px;
  }
`;

const DisplayCard: React.FC<Props> = ({ header, count }): JSX.Element => {
  return (
    <StyledContainer>
      <h5>{header}</h5>
      <p>{count}</p>
    </StyledContainer>
  );
};

export default memo(DisplayCard);
